import { QUERY_STATE } from '@tmapy/utils';
const initialState = {
    currentNoteId: null,
    saveQueryState: QUERY_STATE.EMPTY,
    isChanged: false,
};
export const getInitialState = () => initialState;
//# sourceMappingURL=initialState.js.map